import { api } from "@/api"
import type { SettingsGratuityFormOutput } from "@/components/SettingsGratuity.vue"
import { queryClient } from "@/queryClient"

type UpdateGratuityOptionsResponse = {
  gratuityOptions: [number, number, number, number]
}

export const updateGratuityOptions = async (
  params: SettingsGratuityFormOutput
) => {
  const { body } =
    await api.put<UpdateGratuityOptionsResponse>(
      "/gratuity-options/",
      { body: params }
    )
  queryClient.setQueryData(
    [BASE_GRATUTIY_OPTIONS_QUERY_KEY],
    body.gratuityOptions
  )
  return body.gratuityOptions
}
